import React from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridContainer from '../../../components/Grid/GridContainer.jsx';
import GridItem from '../../../components/Grid/GridItem.jsx';
import Card from '../../../components/Card/Card.jsx';
import CardBody from '../../../components/Card/CardBody.jsx';

// import entitiesStyles from "./EntitiesStyles";
import CardHeader from '../../../components/Card/CardHeader';
import CardIcon from '../../../components/Card/CardIcon';
import PermIdentity from '@material-ui/icons/PermIdentity';
import Button from '../../../components/CustomButtons/Button';

import {connect} from 'react-redux';
// import GroupEdit from "./GroupEdit";
import {selectEntityUi} from '../../../redux/actions/groups';

/**
 * ----------------------------------------------------------------------------
 * STYLING
 * ----------------------------------------------------------------------------
 */
import {cardTitle} from '../../../assets/jss/material-dashboard-pro-react.jsx';
//import TeamEditContainer from "../../../components/Teams/TeamEditContainer"; //Group component
import GroupEditComponentContainer from '../../../components/Groups/GroupEdit'; //Group component"
import {withRouter} from 'react-router-dom';

const entitiesStyles = {
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    '& small': {
      fontSize: '80%',
      fontWeight: '400'
    }
  },
  cardCategory: {
    marginTop: '10px',
    color: '#999999 !important',
    textAlign: 'center'
  },
  description: {
    color: '#999999'
  },
  updateProfileButton: {
    float: 'right'
  },
  title: {
    color: '#3C4858',
    textDecoration: 'none'
  },

  flexEnd: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

/**
 * ----------------------------------------------------------------------------
 * CLASS - Group Edit
 * ----------------------------------------------------------------------------
 */
class GroupEdit extends React.Component {
  render() {
    const {classes} = this.props;
    // console.log(this.props);
    return (
      <div>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <PermIdentity />
            </CardIcon>
            <div className={classes.flexEnd}>
              <h4 className={classes.cardIconTitle}>Group Edit</h4>
              <div>
                <Button round color={null} onClick={() => this.props.history.push('/groups/list')}>
                  Show All
                </Button>
                <Button round color={null} onClick={() => this.props.history.push('/groups/new')}>
                  Create New
                </Button>
                {/*{this.props.divisions.divisions_current_ui === "edit" && (*/}
                <Button
                  round
                  color={'rose'}
                  // onClick={() => this.props.selectEntityUi("edit")}
                >
                  Edit Record
                </Button>
                {/*)}*/}
                {/*{(this.props.divisions.divisions_current_ui !== "edit" && this.props.divisions.divisions_current_ui !== "create") && (*/}
                {/*  <Button*/}
                {/*    round*/}
                {/*    onClick={() => this.props.selectEntityUi("list")}*/}
                {/*  >*/}
                {/*    Refresh*/}
                {/*  </Button>*/}
                {/*)}*/}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                {/*<TeamEditContainer team_id={this.props.match.params.team_id}/>*/}
                <GroupEditComponentContainer group_id={this.props.match.params.group_id} />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    );
  }
}

// GroupEdit.propTypes = {
//   classes: PropTypes.object.isRequired
// };

// export default withRouter(withStyles(entitiesStyles)(GroupEdit));

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    groups: state.groups
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    }
  };
};

const GroupEditContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(entitiesStyles)(GroupEdit)));

export default GroupEditContainer;
